module.exports = {
  get(url, params){
    return new Promise(resolve => {
      const newUrl = `/interface${url}`;
      $.ajax({
        url: newUrl, data: params, dataType: 'json', type: 'get',
        success(result, status, xhr){
          resolve({err: null, res: result});
        },
        error(xhr, status, error){
          resolve({err: error, res: null});
        }
      })
    });
  },
  post(url, params){
    return new Promise(resolve => {
      const newUrl = `/interface${url}`;
      $.ajax({
        url: newUrl, data: params, dataType: 'json', type: 'post',
        success(result, status, xhr){
          resolve({err: null, res: result});
        },
        error(xhr, status, error){
          resolve({err: error, res: null});
        }
      })
    });
  }
};